<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@font-face {
  font-family: 'oaimFont';
  src:  url('words/ArialMTStd-Light.otf') format('woff2');
}
#app{
  font-family: 'oaimFont';
}
</style>



// WEBPACK FOOTER //
// src/App.vue